import canUseDom from 'app/utilities/dom';
import classnames from 'classnames';
import Icon from 'app/components/partials/icon';
import Logo from 'static/images/logos/aag-logo.png';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { EmailShareButton, FacebookShareButton, PinterestShareButton, TumblrShareButton, TwitterShareButton } from 'react-share';
import React, { useState } from 'react';
import { SITE_DESC, SITE_NAME } from '../../../config/app';

function getLocationParams() {
    // Must check whether we are on server or client side
    if (canUseDom()) {
        return {
            title: document.title,
            location: window.location.href,
            domain: window.origin,
        };
    }

    return {
        title: '',
        location: '',
        domain: '',
    };
}

// using library react-share
// each share button props can be found in here: https://www.npmjs.com/package/react-share
// MIT license
const SocialSharingBtn = ({ popupDir = 'top', iconOnly = false }) => {
    const { title, location, domain } = getLocationParams();

    const [clicked, isClicked] = useState(false);
    const body = `${title}\n${location}\n\n${SITE_DESC}`;
    const rootSocialClass = classnames('social-sharing', iconOnly && 'icon-only');
    const socialClass = classnames('social-links', clicked && 'open', popupDir);
    const socialBtnClick = () => {
        isClicked(!clicked);
    };

    return (
        <div className={rootSocialClass}>
            {iconOnly ?
                <Icon name="share" width="20" height="20" onClick={socialBtnClick} />
                :
                <button href="#" className="share-toggle" onClick={socialBtnClick}>
                    <Icon name="share" width="16" height="19" />
                </button>
            }

            <div className={socialClass}>
                <TwitterShareButton url={location} title={`${title} ${SITE_DESC}`} via={SITE_NAME} openShareDialogOnClick={true}>
                    <Icon name="twitter" width="20" height="20" />
                </ TwitterShareButton>
                <FacebookShareButton url={location} openShareDialogOnClick={true}>
                    <Icon name="facebook" width="20" height="20" />
                </ FacebookShareButton>
                <PinterestShareButton url={location} media={`${domain}${Logo}`} description={SITE_DESC} openShareDialogOnClick={true}>
                    <Icon name="pinterest" width="20" height="20" />
                </ PinterestShareButton>
                <TumblrShareButton url={location} content={SITE_DESC} title={title} openShareDialogOnClick={true}>
                    <Icon name="tumblr" width="20" height="20" />
                </ TumblrShareButton>
                {/* set url to empty because we already added it to the body */}
                <EmailShareButton url="" subject={title} body={body}>
                    <Icon name="email" width="20" height="20" />
                </EmailShareButton>
                <div className="arrow"></div>
            </div>
        </div>
    );
};

SocialSharingBtn.propTypes = {
    popupDir: PropTypes.string,
    iconOnly: PropTypes.bool
};

// Wrap the button and depend on location hook to force the component to re-mount when page changes
// This allows the correct title, location, and domain to be set in the component
const SocialSharingBtnWrapper = (props) => {
    const location = useLocation();

    return <SocialSharingBtn key={location.pathname} {...props} />;
};

// export default SocialSharingBtn;
export default SocialSharingBtnWrapper;
